<template>
  <div class="col-12 bg-white-primary mx-auto">
    <div class="size-16 fw-bold text-center py-4 border-bottom">ポートフォリオURL</div>
    <div class="row mx-3 py-4">
      <div class="input-group row">
        <div class="col-12 pe-0">
          <label class="form-label size-12" for="">URL</label>
          <Field v-slot="{ field, errors }" v-model="skillStore.portfolio_url" name="portfolio_url">
            <input
              type="text"
              class="input-primary form-control bg-silver-primary p-0d8 size-14 border-0"
              v-bind="field"
              :class="{ 'is-invalid': !!errors.length }"
              placeholder="例）sample.com"
            />
          </Field>
          <ErrorMessage name="portfolio_url" class="invalid-feedback" />
          <label class="form-label size-12 col-md-12 mt-2 mb-0">
            <span class="me-2">&#8226;</span>
            ポートフォリオ（サービス/github/FigmaなどのURL）をお持ちであればURLを入力してください。
          </label>
          <label class="form-label size-12 col-md-12">
            <span class="me-2">&#8226;</span>
            複数URLをお持ちの方は、自己PRや職務経歴にご記載ください。
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useSkillStore } from '@/stores/resume-candidate/Skill.store';
import { Field, ErrorMessage } from 'vee-validate';

const skillStore = useSkillStore();
</script>
